import { makeAutoObservable } from "mobx";
import { v4 as uuid } from "uuid";
class quickCutStore {
  quickcutData = {
    parse_name: '', // 脚本名称
    scenes: [], // 镜头
    transitions: {}, // 转场
    settings: {
      general: {
        mode: 'follow_audio', // 素材原始时长|随音频时长|自定义时长 origin|follow_audio|custom
        allow_repeat: true // 是否循环播放
      },
      copy: { // 文案配置
        copy_id: null,  // 引用的文案ids
        copy_name: null,  // 引用的文案ids
        copy_type: 1,
        show_subtitle: true, // 显示字幕
        voice: {
          speed_ratio: 1,
          volume_ratio: 1,
          pitch_ratio: 1,
          speaker: []
        }
      },
      video_template: [], // 视频模板
      cover_template: [], // 封面模板
      effect: [], // 特效
      filter: [], // 滤镜
      background: {
        enable_blur: true, // true 高斯模糊 纯黑
        musics: [], // 背景音乐
        music_volume: 30 // 背景音乐音量
      }
    },
    global: true
  }
  preivewData = []
  previewFilter = []
  previewTexts = []
  outputCount = undefined
  videoTemplates = []
  coverTemplates = []
  editDuration = null
  constructor() {
    makeAutoObservable(this);
  }

  public initData() {
    this.previewFilter = [] // 预览特效
    this.previewTexts = [] // 预览文案
    this.preivewData = []
    this.videoTemplates = []
    this.coverTemplates = []
    this.quickcutData = {
      parse_name: '', // 脚本名称
      scenes: [{
        id: uuid(),
        name: "镜头名称",
        materials: [],
        material_mute: true,
        type: 2,
        duration: null,
        settings: {
          copy: {
            copy_id: null
          },
          general: {
            mode: "follow_audio"
          }
        }
      }], // 镜头
      transitions: {}, // 转场
      settings: {
        general: {
          mode: 'follow_audio', // 素材原始时长|随音频时长|自定义时长 origin|follow_audio|custom
          allow_repeat: true // 是否循环播放
        },
        copy: { // 文案配置
          copy_id: null,  // 引用的文案ids
          copy_name: null,  // 引用的文案ids
          copy_type: 1,
          show_subtitle: true, // 显示字幕
          voice: {
            speed_ratio: 1,
            volume_ratio: 1,
            pitch_ratio: 1,
            speaker: []
          }
        },
        video_template: [], // 视频模板
        cover_template: [], // 封面模板
        effect: [], // 特效
        filter: [], // 滤镜
        background: {
          enable_blur: true, // 高斯模糊
          musics: [], // 背景音乐
          music_volume: 30 // 背景音乐音量
        }
      },
      global: true
    }
  }

}

const quickStore = new quickCutStore();

export default quickStore;
